export default __webpack_public_path__ + "static/media/hand-with-gift.767e43a3.svg";